export const chartsHints = {
  charts: 'This page is dedicated to sum of all statistics data.',
  accountsChart: 'Count of unique addresses that were active on the network as a sender or receiver.',
}
